<template>
  <div class="rodemap">
    <WordDialog :key="index" :data="arr[index]" @jump="jump"></WordDialog>
  </div>
</template>

<script>
//script
import Tools from '../../../scripts/tools';
import { gsap } from 'gsap';
//Global
import Global from '../../../scripts/Global';
import WordDialog from '../../cmp/wordDialog';

export default {
  data() {
    return {
      index: 0,
      arr: [
        {
          headImg: '乔诗语讲解',
          word:
            '承光门是御花园顺贞门内南北向之门，这个门就和人家的美貌一样，装饰作用更强一些，它的主要作用和影壁相似，用于遮蔽视线。',
          audio: 'qsy',
          scene: 'scene5',
        },
      ],
    };
  },
  components: {
    WordDialog,
  },
  created() {},
  computed: {},
  methods: {
    jump(event) {
      this.index += 1;
      if (this.arr.length === this.index) {
        this.$router.replace('/rodemap/qsy/04');
        this.index--;
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.rodemap {
  background-image: url(//cdn.original-fun.com/gugong/承光门.jpg);
  background-position: center;
  width: 100vw;
  height: 100vh;
  max-width: 75vh;
  margin: 0 auto;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
